/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const CheckCircle = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }],
    ["path", { d: "m9 11 3 3L22 4" }]
  ]
];

export { CheckCircle as default };
//# sourceMappingURL=check-circle.js.map
